// extracted by mini-css-extract-plugin
module.exports = {"ResetPasswordPage":"ResetPasswordPage_ResetPasswordPage__3neCI","Form":"ResetPasswordPage_Form__2Nemu"};